import { getCall } from "../../../../../axios/api";
import {
  clearingAccountChartDetailsUrl,
  clearingAccountReportExportUrl,
  clearingAccountReportUrl
} from "../../../../../axios/services/apiList";

export function clearingAccountReportList({ queryParams }) {
  return getCall(clearingAccountReportUrl({ queryParams }));
}

export function clearingAccountReportExportList({ queryParams }) {
  return getCall(clearingAccountReportExportUrl({ queryParams }));
}

export function clearingAccountChartDetails({ queryParamsChart }) {
  return getCall(clearingAccountChartDetailsUrl({ queryParamsChart }));
}
